import { useState } from 'react'
import { UserLoginForm, ForgotPasswordForm } from 'components/forms/user_login'
import Aos from 'aos'

export default function UserLogin() {

    Aos.init();
    const [toggle, setTogggle] = useState(false)

    return (
        <>
            <div className='row side_bg g-0'>
                {!toggle ?
                    <>
                        <div className="col-lg-4 m-auto position-relative" data-aos="fade-left" data-aos-duration="1000">
                            <UserLoginForm setTogggle={setTogggle} />
                        </div>
                        <div className="col-lg-5"></div>
                    </>
                    : ''
                }

                {toggle ?
                    <>
                        <div className="col-lg-4 m-auto position-relative" data-aos="fade-left" data-aos-duration="1000">
                            <ForgotPasswordForm setTogggle={setTogggle} />
                        </div>
                        <div className="col-lg-5"></div>
                    </>
                    : ''
                }
            </div>
        </>
    )
}